import React from 'react';

export default function Navigation({ activeSection, setActiveSection }) {
  return (
    <nav className="border-b-2 border-black sticky top-0 bg-stone-100 z-10">
      <div className="max-w-5xl mx-auto px-6 md:px-12 lg:px-24 flex">
        <button
          onClick={() => setActiveSection('product')}
          className={`flex-1 py-5 font-black text-xl border-r-2 border-black transition-all rounded-tl-lg ${
            activeSection === 'product' 
              ? 'bg-sky-200' 
              : 'hover:bg-stone-100'
          }`}
        >
          PRODUCT
        </button>
        <button
          onClick={() => setActiveSection('dev')}
          className={`flex-1 py-5 font-black text-xl transition-all rounded-tr-lg ${
            activeSection === 'dev' 
              ? 'bg-emerald-200' 
              : 'hover:bg-stone-100'
          }`}
        >
          DEV
        </button>
      </div>
    </nav>
  );
}
